import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import { useMediaQuery } from '@react-hook/media-query';
import { mediaQuery } from '@modernhealth/vital-foundation';
import { pxToRem } from '../../helpers/pxToRem';
import styles from './Grid.module.scss';
var ComponentNames;
(function (ComponentNames) {
    ComponentNames["Grid"] = "Grid";
    ComponentNames["GridItem"] = "GridItem";
})(ComponentNames || (ComponentNames = {}));
const lgModeConfig = {
    '5columns': {
        columns: 5,
        gap: 16,
    },
    '3columns': {
        columns: 3,
        gap: 32,
    },
};
export const Grid = ({ children, lgMode = '5columns' }) => {
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));
    const mediumScreenDetected = useMediaQuery(mediaQuery.maxWidth('xl', true));
    const config = lgModeConfig[lgMode];
    const chooseColumnsNumber = () => {
        if (smallScreenDetected) {
            return 1;
        }
        if (mediumScreenDetected) {
            return 4;
        }
        return config.columns;
    };
    return (_jsx(Container, { "data-component": ComponentNames.Grid, columns: chooseColumnsNumber(), gap: config.gap, children: children }));
};
const Container = styled.div(({ columns, gap }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr);`,
    gridColumnGap: pxToRem(gap),
    gridRowGap: pxToRem(24),
}));
export const GridItem = ({ children, lg, md, column, hide, }) => {
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));
    const mediumScreenDetected = useMediaQuery(mediaQuery.maxWidth('xl', true));
    const chooseSpan = () => {
        if (smallScreenDetected) {
            return 1;
        }
        if (mediumScreenDetected) {
            return md;
        }
        return lg;
    };
    if (hide && hide === 'md' && mediumScreenDetected) {
        return null;
    }
    if (hide && hide === 'sm' && smallScreenDetected) {
        return null;
    }
    return (_jsx(ItemContainer, { span: chooseSpan(), className: clsx([column && styles.flexColumn]), "data-component": ComponentNames.GridItem, children: children }));
};
const ItemContainer = styled.div(({ span }) => ({
    gridColumnEnd: `span ${span}`,
    display: 'flex',
}));
